import { defineComponent } from "vue";
import { tv } from "tailwind-variants";

const DisplayClass = tv({
  slots: {
    base: "h-[42px] w-full px-3 py-1 border flex-col justify-center items-center inline-flex",
    title: "text-center text-gray-500 text-[10px] font-normal font-['Inter'] leading-[15px]",
    value: "text-center text-[#111928] text-sm font-medium font-['Inter'] leading-[21px]",
  },
  variants: {
    tone: {
      default: {
        base: "bg-gray-100 border-gray-300",
      },
      danger: {
        base: "bg-red-100 border-red-400",
        value: "text-red-500"
      },
    },
  },
  defaultVariants: {
    tone: "default",
  },
});

export const Display = defineComponent<{ title?: string; value?: string; tone?: 'default' | 'danger'; }>((props) => {
  return () => {
    const cls = DisplayClass({ tone: props.tone as any });
    return (
      <div class={[cls.base()].filter(Boolean).join(" ")}>
        <div class={cls.title()}>
          {props.title}
        </div>
        <div class={cls.value()}>
          {props.value}
        </div>
      </div>
    )
  }
}, { props: ['title', 'value', 'tone'] })
